module.exports = __webpack_public_path__ + "static/media/bootstrap_ps.e5748d89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/skills/bootstrap_ps.png
// module id = 418
// module chunks = 1